<template>
  <CRow>
    <CDropdown
      :toggler-text="sortBy"
      placement="right-start"
      addTogglerClasses="customDropDownColor"
    >
      <CDropdownItem @click="sortBy = 'Sort by Newest'">Newest</CDropdownItem>
      <CDropdownItem @click="sortBy = 'Sort by Name'">Name</CDropdownItem>
      <CDropdownItem @click="sortBy = 'Sort by Online User'">Online User</CDropdownItem>
      <CDropdownItem @click="sortBy = 'Sort by Enrolled User'">Enrolled User</CDropdownItem>
      <CDropdownItem @click="sortBy = 'Sort by Complete'">Complete</CDropdownItem>
      <CDropdownItem @click="sortBy = 'Sort by Posted'">Posted</CDropdownItem>
      <CDropdownItem @click="sortBy = 'Sort by Sharing'">Sharing</CDropdownItem>
      <CDropdownItem @click="sortBy = 'Sort by Income'">Income</CDropdownItem>
    </CDropdown>
    <div style="margin-left:  0.125rem; margin-right:  0.125rem" />
    <component :is="orderOption(sortBy)" />
  </CRow>
</template>

<script>
import alphabeticalOrder from "./alphabeticalOrder";
import amountOrder from "./amountOrder";
export default {
  name: "sortingCourse",
  components: {
    alphabeticalOrder,
    amountOrder
  },
  data() {
    return {
      sortBy: "Sort by Newest"
    };
  },
  methods: {
    orderOption(sortBy) {
      if (sortBy === "Sort by Newest") {
        return null;
      } else if (sortBy === "Sort by Name") {
        return "alphabeticalOrder";
      } else {
        return "amountOrder";
      }
    }
  }
};
</script>
